import { render } from "./topBlock.vue?vue&type=template&id=29cbf20a"
import script from "./topBlock.vue?vue&type=script&lang=js"
export * from "./topBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__